import { urlDateToDateTime } from 'common/UrlDate';
import { first } from 'lodash';
import React from 'react';
import { useRouteMatch } from 'react-router';
import { useDatePickerReducer } from 'src/pages/consumer/components/DishFirstHeader/store';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { useConsumerExploreDishFirstZipCode } from '../../hooks';
import { DropdownArrow, DropdownArrowContainer, DropdownLink, DropdownTextContainer } from '../DatePicker/styles';
import { isDateTomorrow } from '../DatePicker/utils';

export const DateFilterButton: React.FC<{ isLargeText?: boolean }> = ({ isLargeText = false }) => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });
  const { zipCode, dateFilters, activeZipCode } = filters;
  const selectedDate = first(dateFilters);
  const { timeZone } = useConsumerExploreDishFirstZipCode(zipCode ?? activeZipCode);
  const { toggle, isShowing } = useDatePickerReducer();
  const appendText = selectedDate ? 'Deliver' : 'Select';
  const selectedDateTime = selectedDate ? urlDateToDateTime(selectedDate, timeZone) : null;
  const isTomorrow = selectedDate ? isDateTomorrow(selectedDate) : false;
  const displayDate = selectedDateTime
    ? `${selectedDateTime?.weekdayShort}, ${selectedDateTime?.monthShort} ${selectedDateTime?.day}`
    : 'delivery date';

  return (
    <div>
      <DropdownLink onClick={toggle} data-cy='date-picker-dropdown'>
        <DropdownTextContainer isLargeText={isLargeText}>
          {appendText}{' '}
          <b>
            <u>{isTomorrow ? 'tomorrow' : displayDate}</u>
          </b>
        </DropdownTextContainer>
        <DropdownArrowContainer isOpen={isShowing}>
          <DropdownArrow />
        </DropdownArrowContainer>
      </DropdownLink>
    </div>
  );
};
